import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import FileUploader from '@/views/components/file/uploader';
import EditAttachments from '@/views/components/file/edit_attachments_v1';
 import {mapGetters} from "vuex";
 import {addEFileAuditApi} from '../service'
export default {
    data() {
        return {
            show: false,
            saving: false,
            params: {
                reason: '',
                bfiles:[]
            },
        }
    },
    computed: {
        ...mapGetters('async', [ 'team_company_mapping_hash']),
        fields() {
            return [
                {
                    label: '',
                    key:'bfiles',
                   
                },
               
                {
                    label: '事项说明',
                    key:'reason',
                    type: 'textareas_field',
                    placeholder: '请补充此次需在法务盖章节点前付款的事项理由。',
                    rows: 4,
                    counter: 500,
                    required: true,
                    rules: [val => !!val || '必填', val => val && val.length <= 500 || '字数不能超过500']
                }
            ]
        },
        cur_customer() {
            return this.$store.state.cur_customer;
        },
    },
    methods: {
        edit(params) {
            setTimeout(() => {
                this.show = true
            }, 100);
            this.params = {
                reason: '',
                bfiles:[],
                id: params.id
            }
        },
        submit() {
            if (this.$refs.base.validate()) {
                this.saving = true
                addEFileAuditApi(this.params).then(() => {
                    this.$Message.success('提交成功！')
                    this.$emit('success')
                    this.show = false
                }).finally(() => {
                    this.saving = false
                })
            }
        }
    },
    render() {
        const _this = this
        return <VModal
            dynamicHeight
            heightRate={0.7}
            v-model={_this.show}
            title="附件上传"
            loading={_this.saving}
            width={600}
            ref="modal"
            ok-text="保存"
            on={{
                ok: () => {
                    this.submit() 
                },
                cancel:() => {
                    this.show = false
                    _this.params = {}
                }
            }}
        >
           
            <VForm ref="base"
                v-model={_this.params}
                fields={_this.fields}
                scopedSlots={{
                    bfiles:({field} = {}) => {
                        return <div style="display:flex">
                        <p style="width:40px">
                            附件
                        </p>
                        <div style="flex:1">
                            <EditAttachments
                                files={_this.params.bfiles}
                                modelType="Contract"
                                modelId={_this.params.id}
                                />
                                <FileUploader 
                                    validateFile={(file) => {
                                        const a = /\.[0-9a-zA-Z]+$/.test(file.name)
                                        if (!a) {
                                          this.$vModal.warning({
                                              title:'提示',
                                              content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
                                          })
                                        }
                                        return a
                                    }}
                                    on={{
                                        uploaded: (bfile) => {
 
                                            _this.params.bfiles.push(bfile)
                                        }
                                    }}/>
                                <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)</span>
                        </div>
                    </div>
                    },
                }}
                />
        </VModal>
    }
}